export function isStandaloneSimoTMode(search: string, envValue?: string): boolean {
  const forced = envValue?.trim().toLowerCase();
  if (forced === "simot" || forced === "standalone") return true;
  if (forced === "simo" || forced === "mission-control") return false;

  const params = new URLSearchParams(search);
  const product = params.get("product")?.trim().toLowerCase();
  return product === "simot" || product === "standalone";
}
